import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nps-manager-dashboard',
  templateUrl: './nps-manager-dashboard.component.html',
  styleUrls: ['./nps-manager-dashboard.component.css']
})
export class NpsManagerDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/platform/nps-manager-dashboard/nps-manager-dashboard.component.ts